import { SevenPointStar } from "./Star";

const words = ["Community", "Culture", "Charity", "Almadafah", "المضافة", "Belonging", "Ahlan Wa Sahlan"];

function Ribbon() {
  return (
    <div className="flex shrink-0 items-center">
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 text-3xl sm:text-5xl ${
              /[\u0600-\u06FF]/.test(w) ? "font-arabic" : "font-serifx italic"
            } text-jordan-sand/90`}
          >
            {w}
          </span>
          <SevenPointStar className="h-5 w-5 text-jordan-red" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-jordan-ink/80 bg-jordan-ink py-6 sm:py-8"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        <Ribbon />
        <Ribbon />
      </div>
    </section>
  );
}
